import { gql } from '@apollo/client';

export const UPDATE_CALMET_WITH_PROCESS_DATA_CONFIGURATION = gql`
    mutation updateCalmetWithProcessDataConfiguration($id: ID!, $input: UpdateCalmetWithProcessDataPatch!) {
        facility {
            modelConfigurations {
                calmetConfigurations {
                    updateCalmetWithProcessData(id: $id, input: $input) {
                        id
                    }
                }
            }
        }
    }
`;
